import { ArrowRight } from "lucide-react";

// HP4 draft — slim clinical-proof band (light blue) with a single CTA.
export const YearsBandV4 = () => (
  <section className="bg-white py-8 lg:py-12" data-testid="hp4-years-band">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-6 lg:px-10">
      <div className="rounded-sm bg-[#E4EEF0] px-7 lg:px-12 py-8 lg:py-9 flex flex-col md:flex-row md:items-center justify-between gap-6">
        <h2 className="text-[22px] sm:text-[26px] lg:text-[30px] leading-[1.1] tracking-[-0.01em] text-riversol-blue max-w-[46rem]">
          14 years of unmatched, clinically proven results.
        </h2>
        <a
          href="https://www.riversol.com/pages/about"
          data-testid="hp4-years-cta"
          className="group shrink-0 inline-flex items-center gap-2 bg-riversol-blue text-white rounded-full px-7 py-3.5 text-[12px] tracking-[0.16em] uppercase font-medium hover:bg-riversol-blueLight transition-colors"
        >
          About us
          <ArrowRight size={15} strokeWidth={1.8} className="transition-transform group-hover:translate-x-0.5" />
        </a>
      </div>
    </div>
  </section>
);

export default YearsBandV4;
